import React, { useCallback, useEffect, useState } from "react";
import "./boxstyle.css";
import HowToBuySection from "./HowToBuySection";
import CountdownTimer from "./CountDown";
import { RoadmapSection } from "./RoadmapSection";
import { TokenomicsSection } from "./TokenomicsSection";
import Footer from "./Footer";
import Phase from "./Phase";
import toast from "react-hot-toast";
import { isAddress } from "ethers"; // v6+
import { ethers } from "ethers";
import { feeds, NETWORKS, aggregatorV3ABI } from "../contracts/aggregatorV3ABI";
import useContract from "../hooks/useContract";
import {
  useAppKit,
  useAppKitAccount,
  useAppKitNetwork,
} from "@reown/appkit/react";
import { mainnet, bsc, base, polygon } from "@reown/appkit/networks";

import { Link } from "react-router-dom";


const Presale = () => {
   const { open } = useAppKit();
  const { isConnected, address } = useAppKitAccount();
  const { chainId, switchNetwork } = useAppKitNetwork();
    // Claim state
  const [claimLoading, setClaimLoading] = useState(false);

  // Core state
  const [paymentType, setPaymentType] = useState("ETH");
  const [amount, setAmount] = useState("");

    const [receivable, setReceiveable] = useState();
  const [price, setPrice] = useState(0);
  const [ethPrice, setEthPrice] = useState(0);
  const [bscPrice, setBscPrice] = useState(0);
  const [polPrice, setPolPrice] = useState(0);
  const [loading, setLoading] = useState(false);
  


    const [showSuccessPopup, setShowSuccessPopup] = useState(false);


  const [paymentDropdownOpen, setIsPaymentDropdownOpen] = useState(false);

  const [totalAllocations, setTotalAllocations] = useState(null);
  const [totalTokensSold, setTotalTokensSold] = useState(null);
  const [totalUsdRaised, setTotalUsdRaised] = useState(null);
  const [stage, setStage] = useState(null);
  const [error, setError] = useState(null);

  const [tonTransactionLink, setTonTransactionLink] = useState(null);
  const [bscWallet, setBscWallet] = useState("");
  const [isBscModalOpen, setIsBscModalOpen] = useState(false);
  const [solBalance, setSolBalance] = useState(0);
  const [totalLoading, setTotalLoading] = useState(false);

  const {
    buy,
    myTokenBalance,
    maxBalances,
    getPrice,
    claimTokens,
    getAppkitBalance,
    buyAndTokens,
    vestTokens,
    claimvestTokens,
    getPresaleAllocation,
    manualvestTokens,
    getVestedAllocation,
    getVestedClaimed,
    getVestedClaimable,
    getUserVestingInfo,
    getUserPresaleBalances 






  } = useContract();



useEffect(() => {
  const _getPrice = async () => {
    const _price = await getPrice();
    setPrice(_price);
  };

  _getPrice(); // Call price fetch regardless of wallet status
}, [getPrice]);


useEffect(() => {
  let intervalId;

  const _balance = async () => {
    const _myBalance = await myTokenBalance();
    console.log(_myBalance);
    setBalance(_myBalance);

    const _maxBalance = await maxBalances();
    console.log(_maxBalance);
    setMaxBalance(_maxBalance);
  };

  if (address) {
    _balance(); // run immediately

    intervalId = setInterval(() => {
      _balance(); // refresh every 10s
    }, 10000);
  }

  return () => {
    if (intervalId) clearInterval(intervalId); // cleanup on unmount or address change
  };
}, [address]);


  const fetchPrices = useCallback(async () => {
    try {
      const prices = {};
      for (const [chain, { rpc, tokens }] of Object.entries(feeds)) {
        const provider = new ethers.JsonRpcProvider(rpc);
        for (const [symbol, address] of Object.entries(tokens)) {
          const feed = new ethers.Contract(address, aggregatorV3ABI, provider);
          const roundData = await feed.latestRoundData();
          const price = Number(roundData.answer) / 1e8;
          prices[symbol] = price;
        }
      }

      // Batch state updates
      if (prices.ETH) setEthPrice(prices.ETH);
      if (prices.BNB) setBscPrice(prices.BNB);
      if (prices.MATIC) setPolPrice(prices.MATIC);

      return prices;
    } catch (error) {
      console.error("Error fetching prices:", error);
      return null;
    }
  }, [feeds, aggregatorV3ABI]);


  
  useEffect(() => {
    fetchPrices();
  }, [fetchPrices]);



  const validateChain = (type, id) => {
    if (type === "ETH" && id === mainnet.id) {
      return true;
    } else if (type === "ETH(Base)" && id === base.id) {
      return true;
    } else if (type === "BNB" && id === bsc.id) {
      return true;
    } else if (type === "POL" && id === polygon.id) {
      return true;
    } else if (type === "SOL") {
      return true;
    } else if (type === "TON") {
      return true;
    }
    return false;
  };

const handlePaymentTypechange = async (newPaymentType) => {
  if (isConnected) {
    setPaymentType(newPaymentType);
    setAmount("");
    setReceiveable("");

    const networks = {
      ETH: { id: 1, name: "Ethereum Mainnet" },
      BNB: { id: 56, name: "Binance Smart Chain" },
      POL: { id: 137, name: "Polygon" },
      BASE: { id: 8453, name: "Base" },
    };

    try {
      if (newPaymentType === "BNB" && chainId !== networks.BNB.id) {
        switchNetwork(bsc);
      } else if (newPaymentType === "ETH" && chainId !== networks.ETH.id) {
        switchNetwork(mainnet);
      } else if (newPaymentType === "POL" && chainId !== networks.POL.id) {
        switchNetwork(polygon);
      } else if (newPaymentType === "ETH(Base)" && chainId !== networks.BASE.id) {
        switchNetwork(base);
      }
    } catch (error) {
      console.error("Network switch failed:", error);
      toast.error("Failed to switch network. Please change it manually in your wallet.");
    }
  } else {
    setPaymentType(newPaymentType);
  }
};



const handlePaymentChange = async (e) => {
  const precision = 15;
  const formatValue = (value) =>
    Math.abs(value) < 1e-6 ? value.toFixed(precision) : parseFloat(value.toFixed(precision));

  const inputName = e.target.name;
  const inputValue = e.target.value;

  const networks = {
    ETH: { id: 1, rate: ethPrice },
    BNB: { id: 56, rate: bscPrice },
    POL: { id: 137, rate: polPrice },
  };

  const activeNetwork = Object.values(networks).find((network) => network.id === chainId);
  const PER_USDT_TO_NATIVE = activeNetwork ? activeNetwork.rate : ethPrice;
  const numericValue = parseFloat(inputValue);

  if (inputValue === "0" || inputValue === "") {
    setReceiveable("");
    setAmount("");
    return;
  }

  if (!price) return;

  if (inputName === "amount") {
    setAmount(inputValue);
    if (!isNaN(numericValue)) {
      let value;
      if (
        paymentType === "ETH" ||
        paymentType === "ETH(Base)" ||
        paymentType === "BNB" ||
        paymentType === "POL"
      ) {
        value = numericValue * price * PER_USDT_TO_NATIVE;
      } else if (paymentType === "USDT" || paymentType === "USDC") {
        value = numericValue * price;
      }
      setReceiveable(formatValue(value).toString());
    }
  } else if (inputName === "receivable") {
    setReceiveable(inputValue);
    if (!isNaN(numericValue)) {
      let value;
      if (
        paymentType === "ETH" ||
        paymentType === "ETH(Base)" ||
        paymentType === "BNB" ||
        paymentType === "POL"
      ) {
        value = numericValue / price / PER_USDT_TO_NATIVE;
      } else if (paymentType === "USDT" || paymentType === "USDC") {
        value = numericValue / price;
      }
      setAmount(formatValue(value).toString());
    }
  }
};











 
  const [copySuccess, setCopySuccess] = useState("");

  const [balance, setBalance] = useState(0);


    const [maxBalance, setMaxBalance] = useState(null);
  useEffect(() => {
    const _balance = async () => {
      const _myBalance = await myTokenBalance();
      console.log(_myBalance);
      setBalance(_myBalance);
      const _maxBalance = await maxBalances();
      console.log(_maxBalance);
      setMaxBalance(_maxBalance);
    };
    if (address) _balance();
  }, [address]);



  const [txDetails, setTxDetails] = useState(null); // Store transaction details
  



 const [referrer, setReferrer] = useState(null);
const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

useEffect(() => {
  const queryParams = new URLSearchParams(window.location.search);
  const ref = queryParams.get("ref");
  if (ref) setReferrer(ref);
}, []);

const referralLink = `${window.location.origin}/presale?ref=${address}`;

const handleBuy = async () => {
  setLoading(true);

  try {
    const parsedAmount = parseFloat(amount || "0");
    if (!parsedAmount || parsedAmount <= 0) {
      toast.error("Enter a valid amount.");
      setLoading(false);
      return;
    }

    if (!maxBalance || parsedAmount > maxBalance?.[paymentType.toLowerCase()]) {
      toast.error(`Not enough ${paymentType} balance`);
      setLoading(false);
      return;
    }

    const referrerToUse = (referrer && isAddress(referrer))
      ? referrer
      : ZERO_ADDRESS;

    await buy(paymentType, parsedAmount, referrerToUse);
    toast.success("Buy Successful");
    setShowPostBuyModal(true);
    setTxDetails({ amount: parsedAmount, tokens: receivable });
  } catch (err) {
    console.error(err);
    toast.error("Error in buying");
  } finally {
    setLoading(false);
  }
};

    const [showPostBuyModal, setShowPostBuyModal] = useState(false);


   const [showPostvestModal, setShowPostvestModal] = useState(false);





const [buyAndTokensLoading, setbuyAndTokens] = useState(false);


const handleVestbuyAndTokens = async () => {
  try {
    setbuyAndTokens(true);
    await buyAndTokens();
    toast.success("Claim Successful");
    window.location.reload();
  } catch (err) {
    console.error(err);

    // Extract error reason from Ethers v6 or v5
    let errorMessage = "Error Claiming";

    if (err?.reason) {
      errorMessage = err.reason;
    } else if (err?.error?.message) {
      errorMessage = err.error.message;
    } else if (err?.data?.message) {
      errorMessage = err.data.message;
    } else if (err?.message) {
      errorMessage = err.message;
    }

    toast.warning(errorMessage); // 👈 show warning toast instead of error
    setbuyAndTokens(false);
  }
};



const [vestLoading, setVestLoading] = useState(false);


const handleVestClaimTokens = async () => {
  try {
    setVestLoading(true);
    await claimvestTokens();
    toast.success("Claim Successful");
    window.location.reload();
  } catch (err) {
    console.error(err);

    let errorMessage = "Error Claiming";

    if (err?.reason) {
      errorMessage = err.reason;
    } else if (err?.error?.message) {
      errorMessage = err.error.message;
    } else if (err?.data?.message) {
      errorMessage = err.data.message;
    } else if (err?.message) {
      errorMessage = err.message;
    }

    toast.warning(errorMessage); // show detailed warning
    setVestLoading(false);
  }
};

const [unclaimedTokens, setUnclaimedTokens] = useState(null);

useEffect(() => {
  const fetchUnclaimedTokens = async () => {
    try {
      const allocation = await getPresaleAllocation();
      setUnclaimedTokens(allocation);
    } catch (error) {
      console.error("Error fetching unclaimed tokens:", error.message || error);
      setError(error.message || "Failed to fetch unclaimed tokens.");
    }
  };

  fetchUnclaimedTokens();
}, [getPresaleAllocation]);






  const [vestAmount, setVestAmount] = useState(null);

  const [handleVestLoading, setHVestLoading] = useState(false);
  const [vestTxHash, setVestTxHash] = useState(null);
  const [isVestModalOpen, setIsVestModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  
const handleVest = async () => {
  const toastId = toast.loading("Processing your vest...");
  setHVestLoading(true);

  try {
    if (!vestAmount || parseFloat(vestAmount) <= 0) {
      toast.update(toastId, {
        render: "Please enter a valid vest amount.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      setHVestLoading(false);
      return;
    }

    const txReceipt = await manualvestTokens(vestAmount); // Your vest function
    if (!txReceipt) throw new Error("Transaction failed");

    // Optionally set tx hash, show modals, reset inputs, etc.
    setVestTxHash(txReceipt.transactionHash);
    setIsVestModalOpen(false);
    setIsSuccessModalOpen(true);
    setVestAmount("");

    toast.update(toastId, {
      render: "Vesting successful!",
      type: "success",
      isLoading: false,
      autoClose: 2000,
    });

    setTimeout(() => {
      window.location.reload();
    }, 1200);
  } catch (err) {
    console.error("Vest failed:", err);
    toast.update(toastId, {
      render: "Vesting failed",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
  } finally {
    setHVestLoading(false);
  }
};





  const [totalVestedTokens, setTotalVestedTokens] = useState(null);
  const [totalVestedClaimedTokens, setTotalVestedClaimedTokens] = useState(null);
  const [totalVestedClaimableTokens, setTotalVestedClaimableTokens] = useState(null);
  



  useEffect(() => {
    if (!address || !isConnected) return;
  
    const fetchVestingData = async () => {
      try {
        const allocation = await getVestedAllocation();
        setTotalVestedTokens(parseFloat(allocation || "0").toFixed(2));
  
        const claimed = await getVestedClaimed();
        setTotalVestedClaimedTokens(parseFloat(claimed || "0").toFixed(2));
  
        const claimable = await getVestedClaimable();
        setTotalVestedClaimableTokens(parseFloat(claimable || "0").toFixed(2));
      } catch (error) {
        console.error("Error fetching vesting data:", error.message || error);
        setError(error.message || "Failed to fetch vesting data.");
      }
    };
  
    fetchVestingData();
  }, [address, isConnected]);
  





    const [cliffTimeLeft, setCliffTimeLeft] = useState(null);
  const [isCliffEnded, setIsCliffEnded] = useState(false);
  
  useEffect(() => {
    let interval;
  
    const fetchCliffCountdown = async () => {
      const vestingData = await getUserVestingInfo(); // Get full vesting info object
  
      if (!vestingData || !vestingData.cliffEndTime) {
        console.error("Invalid vesting data or cliffEndTime not available");
        return;
      }
  
      const endTime = vestingData.cliffEndTime * 1000; // Convert from seconds to ms
  
      interval = setInterval(() => {
        const now = Date.now();
        const diff = endTime - now;
  
        if (diff <= 0) {
          setCliffTimeLeft("00:00:00");
          setIsCliffEnded(true);  // Enable claim or unlock UI
          clearInterval(interval);
        } else {
          const hours = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, '0');
          const minutes = String(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
          const seconds = String(Math.floor((diff % (1000 * 60)) / 1000)).padStart(2, '0');
  
          setCliffTimeLeft(`${hours}:${minutes}:${seconds}`);
        }
      }, 1000);
    };
  
    if (isConnected) {
      fetchCliffCountdown();
    }
  
    return () => clearInterval(interval); // Cleanup
  }, [isConnected]);
  



    // Contract data states
  const [totalUsers, setTotalUsers] = useState(null);




  const [ethBalance, setEthBalance] = useState("0.0000");
  const [otherBalance, setOtherBalance] = useState("0.0000");
  const [balanceLoading, setBalanceLoading] = useState(false);
  // 👇 Run once on address change
useEffect(() => {
  const fetchBalances = async () => {
    if (!address) return;

    console.log("🔄 Fetching presale balances for address:", address);

    setBalanceLoading(true);
    setError(null);

    try {
      const { ethereum, others } = await getUserPresaleBalances(address);

      console.log("✅ Ethereum balance:", ethereum);
      console.log("✅ Other networks balance (Polygon, Base, BSC):", others);

      setEthBalance(ethereum);
      setOtherBalance(others);
    } catch (err) {
      console.error("❌ Error fetching balances:", err.message);
      setError("Failed to fetch balances.");
    } finally {
      setBalanceLoading(false);
      console.log("✅ Balance fetch complete");
    }
  };

  fetchBalances();
}, [address]);

// Claim tokens
  const GOOGLE_SHEET_API = "https://script.google.com/macros/s/AKfycbwW2VqWHL9T_xUhAxQTytEkrwPrBVD94XDhZL5d1Cn10ntYXwrG6kW6fDbWtsC9d68Y/exec";




const handleClaimTokens = async () => {
  if (!isConnected || !address) {
    toast.error("Please connect your wallet");
    return;
  }

  if (claimLoading) return;

  setClaimLoading(true);

  const networks = {
    ETH: { id: 1, name: "Ethereum Mainnet" },
  };

  try {
    const ethBal = Number(ethBalance);
    const otherBal = Number(otherBalance);

    // ✅ Ethereum claim path
    if (ethBal > 0) {
  if (chainId !== networks.ETH.id) {
  switchNetwork(mainnet);
  console.log("🔁 Switching to Ethereum Mainnet...");
}


      await claimTokens();
      toast.success("Claim successful! 🎉");
      setShowSuccessPopup(true);
      return;
    }

    // ✅ Other chain (Merkle-based) claim
    if (otherBal > 0) {
      if (chainId !== networks.ETH.id) {
  switchNetwork(mainnet);
  console.log("🔁 Switching to Ethereum Mainnet...");
}

      let data;
      try {
        const res = await fetch(`${GOOGLE_SHEET_API}?address=${address}`);
        data = await res.json();
      } catch {
        throw new Error("Failed to fetch Merkle proof.");
      }

      if (data.error) {
        toast.error(`Merkle claim error: ${data.error}`);
        return;
      }

      const proof = typeof data.proof === "string" ? JSON.parse(data.proof) : data.proof;
      const amount = data.amount;

      console.log("🟡 Claiming via Merkle (other chain)...", { amount });

      await claimTokens({ amount, proof });
      toast.success("Claim successful! 🎉");
      setShowSuccessPopup(true);
      return;
    }

    toast.error("No tokens to claim on any network.");
  } catch (err) {
  console.error("Claim error (full):", err);

  if (err.code === 4001 || err.message?.toLowerCase().includes("user rejected")) {
    toast.error("Transaction rejected by user.");
  } else {
    toast.error("Claim failed.");
  }
}
 finally {
    setClaimLoading(false);
  }
};

  


const [showViewVestBox, setShowViewVestBox] = useState(false);

const handleVestTokensbuy = async () => {
  try {
    setLoading(true);
    await vestTokens();
    toast.success("Claim Successful");
    
    setShowViewVestBox(true); // Show modal

    // Wait 3 seconds before reload
    setTimeout(() => {
      window.location.reload();
    }, 300000); // Adjust the delay as needed (in ms)
  } catch (err) {
    console.log(err);
    toast.error("Error Claiming");
    setLoading(false);
  }
};


  // --- UI (all styles and structure unchanged) ---
  return (
      <div className="relative w-full  overflow-hidden bg-transparent">
      {/* ...SVG and header section... */}
      <section className=" py-15 px-8 max-md:py-16 max-md:px-4">
        <div className="max-w-[1440px] mx-auto flex items-center justify-between gap-16 max-md:flex-col-reverse">
          {/* Left Side */}
          <div className="w-1/2 max-md:w-full">
            <div className="overflow-x-auto max-w-full flex justify-start max-md:justify-start">
              <div
                dangerouslySetInnerHTML={{
                  __html: `
<svg width="100%" height="39" viewBox="0 0 560 39" fill="none" xmlns="http://www.w3.org/2000/svg" class="header-icon" style="min-width:240px;max-width:100%;">
  <circle cx="16" cy="19.5" r="16" fill="url(#paint0_linear)" />
  <circle cx="16" cy="19.5" r="8" fill="#473256" />
  <text fill="url(#paint1_linear)" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="clamp(18px,5vw,32px)" font-weight="500" letter-spacing="0em">
    <tspan x="42" y="31.1364">Welcome to Baby Unicorn AI</tspan>
  </text>
  <defs>
    <linearGradient id="paint0_linear" x1="6.46305" y1="11.7963" x2="30.555" y2="11.7963" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFA8D1" />
      <stop offset="0.475962" stop-color="#C3B1FF" />
      <stop offset="1" stop-color="#AEE2FF" />
    </linearGradient>
    <linearGradient id="paint1_linear" x1="125.414" y1="10.1111" x2="536.351" y2="10.1111" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFA8D1" />
      <stop offset="0.475962" stop-color="#C3B1FF" />
      <stop offset="1" stop-color="#AEE2FF" />
    </linearGradient>
  </defs>
</svg>
`,
                }}
              />
            </div>
            <h1 className="text-[58px] font-extrabold text-white leading-[1.2] max-md:text-4xl max-md:leading-snug font-fredoka">
              Gateway to the <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
                Future of Crypto
              </span>
            </h1>
            <p className="mt-8 text-xl text-white max-w-xl leading-relaxed max-md:text-base max-md:mt-4">
              Join the $BABYU token presale now and be part of the revolution
            </p>
            {/* Trusted Users Row */}
            <div className="flex items-center gap-4 mt-10 max-md:mt-6">
              <div className="flex -space-x-3">
                {[45, 46, 47, 48, 49].map((i) => (
                  <img
                    key={i}
                    src={`https://randomuser.me/api/portraits/thumb/men/${i}.jpg`}
                    alt="user"
                    className="w-12 h-12 rounded-full border-2 border-white"
                  />
                ))}
              </div>
              <span className="text-white text-base">25,000+ Trusted People</span>
            </div>
          </div>
          {/* Right Side Unicorn Image */}
          <div className="w-1/2 flex justify-center max-md:w-full">
            <img
              src="Group 86.png"
              alt="Baby Unicorn"
              className="max-w-[520px] w-full"
            />
          </div>
        </div>
      </section>

      {/* Presale Modal Section */}
      <section className="w-full min-h-screen flex flex-col md:flex-col lg:flex-row justify-center items-center gap-8 px-2 sm:px-4 py-10 ">
        {/* LEFT COLUMN: Visual Block */}
        <div className="w-full md:w-[625px] flex-shrink-0 flex flex-col items-center">
          <div className="relative z-20 w-full max-w-[625px] h-64 sm:h-96 md:h-[799px] rounded-3xl overflow-visible flex items-center justify-center">
            <img
              src="Group 90.png"
              alt="Baby Unicorn"
              className="absolute inset-0 w-full h-full object-contain"
            />
          </div>
          {/* Notification Bar Below Image */}
          <div className="frame-2g z-10 mt-[-25px] md:mt-[-95px] w-[95%] md:w-[502px] flex items-center justify-center gap-2.5 h-16 md:h-[142px] pt-4 md:pt-12 pb-2 md:pb-8 px-2 md:px-6 bg-[#3a3350] rounded-xl border-none shadow-lg">
            <p className="w-full md:w-[458px] font-normal text-white text-sm md:text-2xl text-center tracking-[0.24px] leading-5 md:leading-8">
              Token Presale is Officially Live! You Can Purchase Baby Unicorn Token
            </p>
          </div>
        </div>

        {/* RIGHT COLUMN: Modal Content */}
<div className="w-full flex justify-center px-2 sm:px-4">
  <div
    className="
      relative
      w-full
      min-h-[920px] sm:min-h-[600px] md:min-h-[816px]
      max-w-full sm:max-w-[480px] md:max-w-[625px]
      md:w-[607px]
      bg-cover bg-center
      md:bg-[100%_100%]
      overflow-hidden
    "
  >
    {/* Background Gradient */}
    <div className="frame-2fg absolute w-[95%] h-[85%] top-[20px] sm:top-[45px] left-1/2 -translate-x-1/2 rounded-3xl bg-[linear-gradient(180deg,rgba(58,51,80,0.6)_0%,rgba(36,31,56,0.6)_100%)] pointer-events-none select-none" />

    <div className="flex flex-col w-full md:w-[570px] items-center relative z-10 mx-auto mt-8 sm:mt-10 md:mt-12 mb-4 sm:mb-6">
      <div className="flex flex-col items-start gap-4 sm:gap-6 md:gap-[42px] pt-4 sm:pt-6 md:pt-[60px] pb-4 sm:pb-6 md:pb-10
        w-full rounded-3xl border-[none] bg-transparent
        px-2 sm:px-4 md:px-8"
      >

        {/* Countdown */}
<div className="w-full flex justify-center items-center overflow-x-auto px-2">
      <CountdownTimer />
    </div>

        {/* Token Price Info */}
        <div className="w-full px-1 sm:px-0 px-[12px]">
          <p className="text-neutral-100 text-sm sm:text-base leading-7">Current Price per $BABYU Token</p>
          <div className="flex justify-between px-2 sm:px-4 md:px-6 py-2 mt-2 bg-[#3a335066] rounded-md backdrop-blur-[10px] shadow-styel-222 frame-11">
            <span className="text-[#dddddd] text-xs sm:text-base font-semibold">Min : 1 USDT</span>
            <span className="text-[#dddddd] text-xs sm:text-base font-semibold">1 USD = {parseInt(price)}</span>
          </div>
        </div>

        {/* Payment Options */}
        <div className="flex flex-col gap-3 w-full px-1 sm:px-0 px-[12px]">
          {/* Row 1 */}
          <div className="flex flex-col sm:flex-row gap-3">
   {/* ETH */}
                  <div
              className={`flex items-center justify-between flex-1 min-w-[140px] px-3 py-2 bg-[#3a335066] rounded-md backdrop-blur-[10px] border ${paymentType === "ETH" ? "border-[#44f68f]" : "frame-11"} mx-1 sm:mx-0`}
              onClick={() => handlePaymentTypechange("ETH")}
              style={{ cursor: "pointer" }}
            >
              <div className="flex items-center gap-2">
                <img className="w-6 h-6" src="https://c.animaapp.com/mch8srslncqdro/img/image-22-1.png" alt="ETH" />
                <span className="text-[#dddddd] text-xs sm:text-base">Pay With ETH</span>
              </div>
              {paymentType === "ETH" && (
                <img className="w-[25px] h-[25px]" src="https://c.animaapp.com/mch8srslncqdro/img/check-circle.svg" alt="Checked" />
              )}
            </div>

            {/* BNB */}
            <div
              className={`flex items-center justify-between flex-1 min-w-[140px] px-3 py-2 bg-[#3a335066] rounded-md backdrop-blur-[10px] border ${paymentType === "BNB" ? "border-[#44f68f]" : "frame-11"} mx-1 sm:mx-0`}
              onClick={() => handlePaymentTypechange("BNB")}
              style={{ cursor: "pointer" }}
            >
              <div className="flex items-center gap-2">
                <img className="w-6 h-6" src="https://c.animaapp.com/mch8srslncqdro/img/group.png" alt="BNB" />
                <span className="text-[#dddddd] text-xs sm:text-base">Pay With BNB</span>
              </div>
              {paymentType === "BNB" && (
                <img className="w-[25px] h-[25px]" src="https://c.animaapp.com/mch8srslncqdro/img/check-circle.svg" alt="Checked" />
              )}
            </div>
         
          </div>
          {/* Row 2 */}
          <div className="flex flex-col sm:flex-row gap-3">
            {/* ETH(Base) */}
            <div
              className={`flex items-center justify-between flex-1 min-w-[140px] px-3 py-2 bg-[#3a335066] rounded-md backdrop-blur-[10px] border ${paymentType === "ETH(Base)" ? "border-[#44f68f]" : "frame-11"} mx-1 sm:mx-0`}
              onClick={() => handlePaymentTypechange("ETH(Base)")}
              style={{ cursor: "pointer" }}
            >
              <div className="flex items-center gap-2">
                <img className="w-6 h-6" src="https://c.animaapp.com/mch8srslncqdro/img/image-22-1.png" alt="ETH Base" />
                <span className="text-[#dddddd] text-xs sm:text-base">Pay With ETH(Base)</span>
              </div>
              {paymentType === "ETH(Base)" && (
                <img className="w-[25px] h-[25px]" src="https://c.animaapp.com/mch8srslncqdro/img/check-circle.svg" alt="Checked" />
              )}
            </div>
            {/* POL/MATIC */}
      
          </div>
          {/* Row 3 */}
          <div className="flex flex-col sm:flex-row gap-3">
            {/* USDT */}
            <div
              className={`flex items-center justify-between flex-1 min-w-[140px] px-3 py-2 bg-[#3a335066] rounded-md backdrop-blur-[10px] border ${paymentType === "USDT" ? "border-[#44f68f]" : "frame-11"} mx-1 sm:mx-0`}
              onClick={() => handlePaymentTypechange("USDT")}
              style={{ cursor: "pointer" }}
            >
              <div className="flex items-center gap-2">
                <img className="w-6 h-6" src="usdt.svg" alt="USDT" />
                <span className="text-[#dddddd] text-xs sm:text-base">Pay With USDT</span>
              </div>
              {paymentType === "USDT" && (
                <img className="w-[25px] h-[25px]" src="https://c.animaapp.com/mch8srslncqdro/img/check-circle.svg" alt="Checked" />
              )}
            </div>
            {/* USDC */}
            <div
              className={`flex items-center justify-between flex-1 min-w-[140px] px-3 py-2 bg-[#3a335066] rounded-md backdrop-blur-[10px] border ${paymentType === "USDC" ? "border-[#44f68f]" : "frame-11"} mx-1 sm:mx-0`}
              onClick={() => handlePaymentTypechange("USDC")}
              style={{ cursor: "pointer" }}
            >
              <div className="flex items-center gap-2">
                <img className="w-6 h-6" src="https://c.animaapp.com/mch8srslncqdro/img/usd-coin-usdc-logo--1--1.svg" alt="USDC" />
                <span className="text-[#dddddd] text-xs sm:text-base">Pay With USDC</span>
              </div>
              {paymentType === "USDC" && (
                <img className="w-[25px] h-[25px]" src="https://c.animaapp.com/mch8srslncqdro/img/check-circle.svg" alt="Checked" />
              )}
            </div>
          </div>
        </div>

        {/* Input Summary */}
     <div className="flex justify-center w-full mt-2 px-[12px]">
  <div className="flex flex-col sm:flex-row gap-2 sm:gap-[15px] w-full">
    {/* AMOUNT */}
    <div className="flex flex-col gap-1 flex-1 min-w-0">
      <label className="text-neutral-100 text-xs sm:text-base" htmlFor="buy-amount">
        Amount ({paymentType})
      </label>
      <div className="frame-11">
        <input
          id="buy-amount"
          type="number"
          name="amount"
    
          value={amount}
          onChange={handlePaymentChange}
          className="
            w-full bg-transparent border-none outline-none
            text-[#dddddd] text-xs sm:text-base
            placeholder:text-neutral-400
            px-2 py-2
          "
          placeholder="Enter amount"
        />
      </div>
    </div>
    {/* RECEIVABLE */}
    <div className="flex flex-col gap-1 flex-1 min-w-0">
      <label className="text-neutral-100 text-xs sm:text-base" htmlFor="get-amount">
        Get Amount ($BABYU)
      </label>
      <div className="frame-11">
        <input
          id="get-amount"
          type="number"
          name="receivable"
          inputMode="decimal"
          value={receivable}
          onChange={handlePaymentChange}
          className="
            w-full bg-transparent border-none outline-none
            text-[#dddddd] text-xs sm:text-base
            placeholder:text-neutral-400
            px-2 py-2
          "
          placeholder="Tokens you get"
        />
      </div>
    </div>
  </div>
</div>



        {/* Buy / Connect Wallet Button */}
 <div className="w-full max-w-[500px] mx-auto mt-[0px] sm:mt-[-20px] px-[12px]">
  {isConnected ? (
    <button
      className={`
        w-full flex items-center justify-center gap-2.5
        min-h-[44px] sm:min-h-[50px] md:min-h-[60px]
        rounded-full
        border-2 border-white
        shadow-[0px_4px_16px_#ff49b8]
        bg-gradient-to-r from-pink-400 via-purple-400 to-sky-400
        ${(!amount || Number(amount) <= 0 || loading) && "opacity-50 cursor-not-allowed"}
        px-4 sm:px-8 py-2
        text-base sm:text-lg md:text-[22px] font-semibold
        transition
      `}
      onClick={handleBuy}
      disabled={!amount || Number(amount) <= 0 || loading}
    >
      <span className="text-white">
        {loading ? "Processing..." : "Buy"}
      </span>
      <img
        className="w-5 h-5 md:w-[25px] md:h-[25px]"
        src="https://c.animaapp.com/mch8srslncqdro/img/arrow-right.svg"
        alt="Arrow"
      />
    </button>
  ) : (
    <button
      onClick={() => open("connect")}
      className="
        w-full flex items-center justify-center gap-2.5
        min-h-[44px] sm:min-h-[50px] md:min-h-[60px]
        rounded-full
        border-2 border-white
        shadow-[0px_4px_16px_#ff49b8]
        bg-gradient-to-r from-pink-400 via-purple-400 to-sky-400
        hover:opacity-90 transition
        px-4 sm:px-8 py-2
        text-base sm:text-lg md:text-[22px] font-semibold
      "
    >
      <span className="text-white">
        Connect Wallet
      </span>
      <img
        className="w-5 h-5 md:w-[25px] md:h-[25px]"
        src="https://c.animaapp.com/mch8srslncqdro/img/arrow-right.svg"
        alt="Arrow"
      />
    </button>
  )}
</div> <div className="w-full max-w-[500px] mx-auto mt-[0px] sm:mt-[-20px] px-[12px]">
<button
  className={`
    w-full flex items-center justify-center gap-2.5
    min-h-[44px] sm:min-h-[50px] md:min-h-[60px]
    rounded-full
    border-2 border-white
    shadow-[0px_4px_16px_#ff49b8]
    bg-gradient-to-r from-pink-400 via-purple-400 to-sky-400 
    ${
      (claimLoading || 
       (parseFloat(ethBalance) === 0 && parseFloat(otherBalance) === 0)
      ) && "opacity-50 cursor-not-allowed"
    }
    px-4 sm:px-8 py-2
    text-base sm:text-lg md:text-[22px] font-semibold
    transition
  `}
  onClick={handleClaimTokens}
  disabled={
    claimLoading ||
    (parseFloat(ethBalance) === 0 && parseFloat(otherBalance) === 0)
  }
>
  <span className="text-white">
    {claimLoading ? "Claiming..." : "Claim Tokens"}
  </span>
  <img
    className="w-5 h-5 md:w-[25px] md:h-[25px]"
    src="https://c.animaapp.com/mch8srslncqdro/img/arrow-right.svg"
    alt="Arrow"
  />
</button></div>

        <div className="flex-1" />
      </div>
      {/* Floating Label */}
 <div className="mt-[-3px] sm:mt-[-12px] text-center inline-flex items-center justify-center gap-2.5 px-4 md:px-9 py-2 md:py-4 absolute -top-6 left-1/2 -translate-x-1/2 bg-[#32273d] rounded-[50px] border-[5px] border-[#392e4b]">
  <p className="text-white text-xs md:text-base font-medium whitespace-nowrap">
    Buy Before Next Price Increase
  </p>
</div>


    </div>
  </div>
</div>



      </section>

   



{showPostBuyModal && (
  <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
    <div className="flex flex-col gap-4 items-center p-5 bg-[#3a3350] rounded-xl border-2 border-solid border-[color:var(--style-222,#2D2842)] w-[440px] max-md:w-full max-md:max-w-[400px] max-sm:gap-3 max-sm:p-4 relative text-white">
      
      {/* Close Button */}
      <button
        className="absolute top-2 right-2 text-white text-xl font-bold"
        onClick={() => setShowPostBuyModal(false)}
      >
        ×
      </button>

      {/* Title */}
      <h2 className="text-xl font-semibold text-white text-center w-full">
        Next Steps
      </h2>

      {/* Subtitle - centered */}
      <p className="text-neutral-100 text-base leading-6 w-full text-center mb-2">
        Choose how you want to proceed
      </p>

      {/* Buttons */}
      <div className="flex flex-col gap-3 w-full">
        <button
          className="mt-1 bg-[linear-gradient(90deg,#FF6EB3_0%,#AA81FF_47.12%,#6BC9FF_100%)] shadow-[0px_4px_16px_#ff49b8] flex gap-2.5 justify-center items-center px-6 py-4 text-lg font-semibold tracking-wide text-white border-2 border-white border-solid min-h-[52px] w-full rounded-[50px]"
          onClick={handleVestTokensbuy}
        >
          <span>Vest Tokens</span>
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/8490b493579621a21a9806eb89a7ed0f66e15b73?placeholderIfAbsent=true&apiKey=0c11d46dd7d64d7a84bf3e17dbee5689"
            className="object-contain w-[20px]"
            alt="Arrow icon"
          />
        </button>

        <button
          className="mt-1 bg-[linear-gradient(90deg,#FF6EB3_0%,#AA81FF_47.12%,#6BC9FF_100%)] shadow-[0px_4px_16px_#ff49b8] flex gap-2.5 justify-center items-center px-6 py-4 text-lg font-semibold tracking-wide text-white border-2 border-white border-solid min-h-[52px] w-full rounded-[50px]"
          onClick={handleClaimTokens}
        >
          <span>Claim Tokens</span>
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/8490b493579621a21a9806eb89a7ed0f66e15b73?placeholderIfAbsent=true&apiKey=0c11d46dd7d64d7a84bf3e17dbee5689"
            className="object-contain w-[20px]"
            alt="Arrow icon"
          />
        </button>
      </div>
    </div>
  </div>
)}



{showViewVestBox && (
  <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
    <div className="flex flex-col gap-4 items-center p-6 bg-[#3a3350] rounded-xl border-2 border-solid border-[#2D2842] w-[400px] max-md:w-full text-white relative">
      
      {/* Close Button */}
      <button
        className="absolute top-2 right-2 text-white text-xl font-bold"
        onClick={() => setShowViewVestBox(false)}
      >
        ×
      </button>

      <h2 className="text-xl font-semibold text-center text-white">Vesting Confirmed</h2>
      <p className="text-neutral-100 text-center text-white">Your tokens are now vested. You can view details on the vesting page.</p>

 <Link
  to="/vesting"
  className="bg-gradient-to-r from-purple-400 to-blue-500 px-6 py-3 text-white font-semibold rounded-full shadow-lg mt-4 text-center block"
  onClick={() => setShowViewVestBox(false)}
>
  Go to Vesting Page
</Link>

    </div>
  </div>
)}


      <HowToBuySection />
      <TokenomicsSection />
      <RoadmapSection />
      <Phase/>
      <Footer />
    </div>
  );
};

export default Presale;
